import { render, staticRenderFns } from "./_CouponsPage.vue?vue&type=template&id=10c1bae8&"
import script from "./_CouponsPage.vue?vue&type=script&lang=ts&"
export * from "./_CouponsPage.vue?vue&type=script&lang=ts&"
import style0 from "./_CouponsPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports